export default {
    Script: {
        getdata: []
    }
};